import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import moment from "moment-hijri";
import DatePicker from "react-multi-date-picker"
import arabic from "react-date-object/calendars/arabic"
import arabic_ar from "react-date-object/locales/arabic_en"
import { SERVER_URL } from '../ConstantsEN';
import { AgeGregorian_EndPoint } from "../ConstantsEN";
import { AgeHijri_EndPoint } from "../ConstantsEN";
import { CalculatorsType } from '../ConstantsEN';
import { Button, FormControlLabel, Radio } from "@mui/material";
import SharedHelmet from "../Helmet";
const TITLE = 'Hijri Age Calculator - Calculate Your Islamic Age Accurately';
const DESCRIPTION = 'Calculate your age in Hijri (Islamic) calendar by entering your birthdate in either Hijri or Gregorian date. Use the Hijri Age Calculator to convert dates into precise ages based on the Islamic calendar.';
const KEYWORDS = 'Hijri age calculation, Islaic age calculator, Convert date to Hijri age, Hijri age calculator, Islamic age calculation, Convert date to Hijri years, Calculate age in Hijri date, Professional Islamic age calculator, Accurate Hijri age calculation, Hijrah date to real age, Calculate a person\'s age in Islamic date, Calculate age according to the Islamic calendar';
const OG_URL = 'https://do-calculate.com/calculator/en/agehijri/';
moment.locale("ar");
const apiEndpointGregorian = `${SERVER_URL}/${AgeGregorian_EndPoint}`;
const apiEndpointHijri = `${SERVER_URL}/${AgeHijri_EndPoint}`;
function AgeCalculatorHijri() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [convertedValue, setConvertedValue] = useState("hijri");
  const handleConversionValueChange = (newConversionType) => {
    setConvertedValue(newConversionType);
    setIsLoading(false);
    setError(null);
    setStatusCode(null);
    setDateOfBirthGregorian("");
    setAgeGregorian(null);
    setAgeHijri(null);
    setValueHijri("");
  };
  const [dateOfBirthGregorian, setDateOfBirthGregorian] = useState("");
  const [ageGregorian, setAgeGregorian] = useState(null);
  const handleDateChangeGregorian = (event) => {
    setDateOfBirthGregorian(event.target.value);
  };
  const calculateAgeGregorian = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpointGregorian, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ dateOfBirth: dateOfBirthGregorian }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setAgeGregorian(data.age);
        setError(null);
      } else {
        setAgeGregorian(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  const [ageHijri, setAgeHijri] = useState(null);
  const [valueHijri, setValueHijri] = useState("");
  const calculateAgeHijri = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpointHijri, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ dateOfBirth: valueHijri.format("YYYY-MM-DD") }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setAgeHijri(data.age);
        setError(null);
      } else {
        setAgeHijri(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: '40px', }}>
            <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                The "Age Calculator" can determine the Hijri age. The calculated age will be displayed in years, months, days, hours, minutes, and seconds. Calculate your age in the Hijri calendar by entering your birthdate in either Hijri or Gregorian date. Use the Hijri Age Calculator to convert dates into precise ages based on the Islamic calendar.<br />              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div
                className="form-group d-flex align-items-center"
                style={{
                  columnGap: "25px",
                  margin: "5px 15px 35px 0",
                }}
              >
                <b>
                  <label >Date Type:</label>
                </b>
                <div style={{ marginRight: "30px" }}>
                  <FormControlLabel
                    value="gregorian"
                    id="gregorianConversion"
                    name="conversionValue"
                    control={
                      <Radio
                        color="success"
                        checked={convertedValue === "gregorian"}
                        onChange={() => handleConversionValueChange("gregorian")}
                      />
                    }
                    label="Gregorian"
                    labelPlacement="start"
                  />
                  <FormControlLabel
                    value="hijri"
                    id="hijriConversion"
                    name="conversionValue"
                    control={
                      <Radio
                        color="success"
                        value="hijri"
                        checked={convertedValue === "hijri"}
                        onChange={() => handleConversionValueChange("hijri")}
                      />
                    }
                    label="Hijri"
                    labelPlacement="start"
                  />
                </div>
              </div>
            </div>
            {convertedValue === "gregorian" ? (
              <div className="row">
                <div className="col">
                  <label htmlFor="dateOfBirth" style={{ fontSize: "16px" }}>
                    Enter your birth date in the Gregorian calendar
                  </label>
                </div>
                <div className="col">
                  <div className="form-group">
                    <input
                      type="date"
                      id="dateOfBirth"
                      value={dateOfBirthGregorian}
                      onChange={handleDateChangeGregorian}
                      className="form-control"
                      lang="ar"
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="row">
                <div className="col">
                  <label htmlFor="hijriDatePicker" style={{ fontSize: "16px" }}>
                    Enter your birth date in the Hijri calendar
                  </label>
                </div>
                <div className="col">
                  <div className="form-group">
                    <DatePicker
                      value={valueHijri}
                      id="hijriDatePicker"
                      calendar={arabic}
                      locale={arabic_ar}
                      onChange={setValueHijri}
                      style={{ padding: "17px 10px" }}
                    />
                  </div>
                </div>
              </div>
            )}
            <div className="row">
              <div className="col text-center">
                <br />
                <Button
                  variant="contained"
                  color="success"
                  onClick={
                    convertedValue === "gregorian"
                      ? calculateAgeGregorian
                      : calculateAgeHijri
                  }
                  sx={{ mb: "5px" }}
                >

                  Calculate

                </Button>
                <br />
              </div>
              <hr />
              <div className="row">
                <RelatedLinks />
                <br />
                <hr />
              </div>
              <div className="row">
                <div className="col">
                  <br />
                  {statusCode === 400 && (
                    <div className="alert alert-warning">
                      <b>
                        <u>Error occurred:</u>
                      </b>{" "}
                      Please enter a valid birth date.
                    </div>
                  )}
                  {ageGregorian && (
                    <div>
                      <br />
                      <div
                        style={{
                          backgroundColor: "#D1E7DD",
                          borderColor: "#c3e6cb",
                          color: "#155724",
                          padding: "15px",
                          marginBottom: "20px",
                          borderRadius: "4px",
                        }}
                      >
                        {" "}
                        <label>
                          <b> Your age is: </b>
                          {ageGregorian.years} years, {ageGregorian.months} months,{" "}
                          {ageGregorian.days} days, {ageGregorian.hours} hours,{" "}
                          {ageGregorian.minutes} minutes, {ageGregorian.seconds} seconds
                        </label>
                      </div>
                    </div>
                  )}
                  {ageHijri && (
                    <div>
                      <br />
                      <div
                        style={{
                          backgroundColor: "#D1E7DD",
                          borderColor: "#c3e6cb",
                          color: "#155724",
                          padding: "15px",
                          marginBottom: "20px",
                          borderRadius: "4px",
                        }}
                      >
                        {" "}
                        <label>
                          <b> Your age is: </b>
                          {ageHijri.years} years, {ageHijri.months} months,{" "}
                          {ageHijri.days} days, {ageHijri.hours} hours,{" "}
                          {ageHijri.minutes} minutes, {ageHijri.seconds} seconds
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col" >
          <SecondAds />
          <br />
          <MainCalculatorsList CalculatorsTypeId={CalculatorsType.humanCalculators}></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: 'auto' }} >
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Age in Hijri Calendar: A Comprehensive Guide to Accurately Calculate Age According to the Hijri Calendar</div>
              <div className="info-section-body">
                <u><h2 style={{ fontSize: '16px' }}>Age in Hijri Calendar: Conversion and Accurate Calculation</h2></u>
                <p>
                  Cultural works and traditions are among the most important aspects that distinguish different cultures around the world. One of the prominent cultures with its own unique calendar is the Hijri calendar, widely used in the Islamic world. In this article, we will discuss the topic of calculating age in the Hijri calendar and how to accurately convert dates into Hijri ages.
                </p>
                <hr />
                <u><h2 style={{ fontSize: '16px' }}>The Concept of Hijri Age</h2></u>
                <p>
                  Hijri age is the method used to calculate a person's age using the Hijri calendar. This type of calculation is based on Hijri years, months, and days. It is primarily used in the Islamic world to calculate ages and determine religious events and occasions.
                </p>
                <hr />
                <u><h2 style={{ fontSize: '16px' }}>How to Calculate Age in the Hijri Calendar</h2></u>
                To accurately calculate age in the Hijri calendar, you should follow these steps:
                <ul>
                  <li>Identify the person's date of birth: You should know the date of birth of the person you want to calculate the Hijri age for.</li>
                  <li>Calculate the number of years: Start by calculating the number of years between the date of birth and the current date using the Hijri calendar.</li>
                  <li>Consider the Hijri months and days: After calculating the years, take into account the Hijri months and days to obtain an accurate Hijri age.</li>
                </ul>
                <hr />
                <u><h2 style={{ fontSize: '16px' }}>Using the Accurate Hijri Age Calculator</h2></u>
                <p>
                  To facilitate the process of calculating age in the Hijri calendar, you can use the accurate Hijri age calculator. This tool quickly and accurately converts the date of birth into the Hijri age. All you need to do is enter the date of birth, and the calculator will provide the result instantly.
                </p>
                <hr />
                <u><h2 style={{ fontSize: '16px' }}>Uses of Calculating Age in the Hijri Calendar</h2></u>
                <p>
                  Calculating age in the Hijri calendar is used in various contexts within the Islamic world. It can be used to determine religious holidays and events such as the month of Ramadan and Eid al-Fitr. It is also used for calculating ages in official documents and licenses.
                </p>
                <hr />
                <u><h2 style={{ fontSize: '16px' }}>How the Hijri Age Calculator Works</h2></u>
                <p>
                  The use of the Hijri calendar to calculate a person's age dates back to Islamic history. The Hijri calendar is based on the migration of the Prophet Muhammad (peace be upon him) from Mecca to Medina in the year 622. The Hijri year consists of 12 months, and the number of days in each month varies according to the Hijri calendar. The Hijri year is shorter than the Gregorian year, which results in differences in dates between the two calendars.
                </p>
                <p>
                  A person's age in the Hijri calendar depends on their date of birth and the current Hijri date. The age can be calculated in years, months, days, hours, minutes, and seconds.
                </p>
                <p>
                  However, it should be noted that the accurate Hijri age depends on the current time and the Hijri date at the moment the code is executed. If the code is run at a specific time, it will provide the current age according to that date.
                </p>
                <p>
                  For example, if today is May 27, 2023, and the date of birth is 1 Muharram 1421, the age will be calculated based on these time differences and the Hijri date.
                </p>
              </div>
            </div>
          </div>
          <br />
          <u><h2>Frequently Asked Questions</h2></u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: '16px' }}>What is the Hijri Age?</h3>
              </div>
              <div className="info-section-body">
                Hijri age is the method we use to measure a person's age using the Hijri calendar, which is the calendar used in the Islamic world.
                <br />
                <label>Source: <a href="https://en.wikipedia.org/wiki/Islamic_calendar">Wikipedia</a></label>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: '16px' }}>How Can I Calculate the Hijri Age?</h3>
              </div>
              <div className="info-section-body">
                You can calculate the Hijri age simply by following these steps:
                <ol>
                  <li>Specify the date of birth.</li>
                  <li>Calculate the number of years between the date of birth and the current date using the Hijri calendar.</li>
                  <li>Consider the Hijri months and days to obtain an accurate age.</li>
                </ol>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: '16px' }}>Is There a Calculator for Hijri Age Calculation?</h3>
              </div>
              <div className="info-section-body">
                Yes, there are several online calculators that help you calculate the Hijri age accurately. Simply enter the date of birth, and the calculator will automatically convert it to Hijri age.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: '16px' }}>What Are the Uses of Hijri Age?</h3>
              </div>
              <div className="info-section-body">
                Hijri age is commonly used in the Islamic world to determine religious and legal dates and to monitor religious events. It is also used in official documents and contracts.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: '16px' }}>Can Hijri Age Be Calculated Manually?</h3>
              </div>
              <div className="info-section-body">
                Yes, Hijri age can be calculated manually using recognized Islamic lunar calendar rules. Simply calculate the years between the date of birth and the current Hijri date, and then consider the months and days.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: '16px' }}>What Is the Significance of Calculating Hijri Age?</h3>
              </div>
              <div className="info-section-body">
                Calculating Hijri age is of great importance in the Islamic world, where it is used to determine religious and legal dates, monitor religious events, and for official documents and licenses.
              </div>
            </div>
          </div>
        </div>
      </div> <br />
    </div>
  );
}
export default AgeCalculatorHijri;
